import { FaDatabase, FaProjectDiagram, FaBusinessTime, FaReact, FaNode, FaSymfony, FaLaravel, FaWordpress, FaWix, FaJava, FaPython, FaHtml5, FaCss3Alt, FaGit, FaGithub, FaRProject, FaFigma } from "react-icons/fa";
import { MdWeb } from "react-icons/md";
import { SiDjango, SiDotnet, SiDynamics365, SiExpress, SiMicrosoftsqlserver, SiMongodb, SiMysql, SiPowerbi, SiRedux, SiSap, SiSpring, SiTalend } from "react-icons/si";
import { DiJavascript } from "react-icons/di";
import {
  colis19,
  erpInceptum,
  ghostprod,
  inceptumwebsite,
  ecodataweb,
  ecodatabi,
  provestaweb,
  strokebi,
  realestatebi,
  netflixbi,
  hrbi,
  soprahrbi,
  soprahrweb,
  /* colis-19 */
  colishome,
  newColis,
  adminHome,
  contactForm,
  employeeDashboard,
  employeesTable,
  employeesTableSm,
  profilePageClient,
  profilePageClientInterface,
  sendForm,
  sendFormInterface,
  signIn,
  signInInterface,
  signUp,
  signUpInterface,
  trackForm,
  trackFormInterface,
  /* erpInceptum */
  createMeetingForm1,
  createMeetingForm2,
  darkmode1,
  darkmode2,
  editerReunion,
  inceptumeet,
  inceptumeet01,
  inceptumeet02,
  inceptumeet03,
  inceptumeet04,
  inceptumeet05,
  login,
  login1,
  meeting1,
  meetingsCollection,
  meetings1,
  meetings2,
  members1,
  notif,
  oneMeetingPage,
  profile1,
  profile2,
  profile3,
  project1,
  projects1,
  pv01,
  pv02,
  pv1,
  pv2,
  pvForm,
  /* ghostprod */
  frontoffice00,
  frontoffice01,
  frontoffice02,
  frontoffice03,
  frontoffice04,
  frontoffice05,
  frontoffice06,
  frontoffice07,
  frontoffice08,
  frontoffice09,
  frontoffice10,
  frontoffice11,
  frontoffice12,
  frontoffice13,
  frontoffice14,
  frontoffice15,
  frontoffice16,
  frontoffice17,
  frontoffice18,
  frontoffice19,
  frontoffice20,
  frontoffice21,
  frontoffice22,
  frontoffice23,
  backoffice00,
  backoffice01,
  backoffice02,
  backoffice03,
  backoffice04,
  backoffice05,
  backoffice06,
  backoffice07,
  backoffice08,
  backoffice09,
  backoffice10,
  backoffice11,
  backoffice12,
  backoffice13,
  mobile00,
  mobile01,
  mobile02,
  mobile03,
  mobile04,
  mobile05,
  mobile06,
  mobile07,
  mobile08,
  mobile09,
  mobile10,
  mobile11,
  mobile12,
  mobile13,
  mobile14,
  mobile15,
  mobile16,
  mobile17,
  mobile18,
  mobile19,
  mobile20,
  mobile21,
  mobile22,
  /* inceptumWebsite */
  home00,
  home01,
  home02,
  home03,
  home04,
  home05,
  home06,
  home07,
  home08,
  home09,
  services00,
  services01,
  services02,
  services03,
  services04,
  services05,
  services06,
  services07,
  services08,
  aboutUs00,
  aboutUs01,
  aboutUs02,
  aboutUs03,
  aboutUs04,
  aboutUs05,
  aboutUs06,
  aboutUs07,
  aboutUs08,
  /* ecodata bi */
  customer,
  dark1,
  dark2,
  dark3,
  dark4,
  fullfilment,
  sales,
  top5,
  /* ecodata web app */
  customers,
  customers01,
  daily01,
  daily02,
  dashboard01,
  dashboard02,
  dashboard1,
  dashboard2,
  form01,
  form02,
  form03,
  forms,
  forms01,
  forms1,
  forms11,
  forms12,
  forms13,
  forms2,
  forms3,
  powerbireport,
  pricing,
  products,
  products01,
  profit01,
  profit02,
  solution,
  /* provesta soft crm */
  c00,
  c01,
  c02,
  c03,
  c0301,
  c04,
  c05,
  c06,
  c07,
  c0701,
  c0702,
  c0703,
  c0704,
  c0705,
  c0706,
  c0707,
  c08,
  cajout,
  cimprimer,
  /* hr analytics bi */
  employees_list,
  employees_performance,
  employees_satisfaction,
  general_info,
  promotion_retreanchment,
  /* netflix bi */
  page01,
  page02,
  /* real estate bi */
  location,
  realestateOverview,
  quality_price,
  /* sopra hr bi */
  absence,
  assignments,
  contracts,
  demographics,
  departure,
  employeesInfo,
  establishments,
  hiring,
  overview,
  salaryPayroll,
  /* sopra hr web app */
  absencePage,
  assignmentsPage,
  careers,
  configurator,
  demographicsPage,
  departurePage,
  employeesInfoPage,
  establishmentsPage,
  hiringPage,
  overviewPage,
  predictAbsencePage,
  predictedAbsenceDaysResult,
  profilePage,
  salaryPayrollPage,
  sopraSignIn,
  sopraSignUp,
  tablesPage,
  /* stroke analysis bi */
  health_conditions,
  home,
  kpis,
  res_work_gender,
  smoking_status,
} from "../assets";

// Services Data
export const servicesData = [
  {
    id: 1,
    icon: <MdWeb />,
    title: "Web Development",
    des: "I offer web development services focused on building responsive, user-friendly websites that make interactions easy and engaging.",
  },
  {
    id: 2,
    icon: <FaDatabase />,
    title: "BI & Data",
    des: "I deliver Business Intelligence and Data Engineering services that turn data into actionable insights.",
  },
  {
    id: 3,
    icon: <FaBusinessTime />,
    title: "Consulting",
    des: "I provide consulting services that help you make informed decisions and achieve your business goals.",
  },
  {
    id: 4,
    icon: <FaProjectDiagram />,
    title: "Project Management",
    des: "I offer Project Management services that help you deliver projects on time and within budget.",
  },
];

export const educationData = [
  {
    id: 1,
    title: "Baccalaureate Diploma in Mathematics",
    subTitle: "Abdelaziz Khouja High School (2014 - 2018)",
    location: "Kelibia, Tunisia",
    des: "I hold a Baccalaureate in Mathematics, which has provided me with a strong foundation in analytical thinking, problem-solving, and quantitative reasoning.",
    keywords: ["Mathematics", "Physics", "Science"]
  },
  {
    id: 2,
    title: "Bachelor Diploma in Computer Science",
    subTitle: "ISIMM - Higher Institute of Informatics and Mathematics of Monastir (2018 - 2021)",
    location: "Monastir, Tunisia",
    des: "I hold a Bachelor’s degree in Computer Science, equipping me with a solid foundation in programming, problem-solving and software development.",
    keywords: ["Computer Science", "Software Development"]
  },
  {
    id: 3,
    title: "Engineering Diploma in Computer Science",
    subTitle: "ESPRIT - Private Higher School of Engineering and Technology (2021 - 2024)",
    location: "Ariana, Tunisia",
    des: "I hold an Engineering Diploma in Computer Science, providing me with advanced expertise in software development, data engineering, and system design, along with a strong foundation in analytical and problem-solving skills.",
    keywords: ["Business Intelligence", "Data", "Software Development"]
  }
];

export const experienceData = [
  {
    id: 1,
    title: "Internship in Web Development",
    subTitle: "GPRO CONSULTING (February 2021 - June 2021)",
    location: "Sousse, Tunisia",
    des: [
      "Established a backend server for a delivery management app, reducing latency by 40% and improving performance.",
      "Designed over 25 user interfaces, resulting in a 30% improvement in usability ratings.",
      "Deployed the app on an external server, ensuring over 90% uptime and supporting 500+ users daily.",
    ],
    keywords: ["NodeJs", "ExpressJs", "ReactJs", "Redux", "MongoDB", "Netlify", "Heroku"]
  },
  {
    id: 2,
    title: "Part-time Web Developer and IT Consultant",
    subTitle: "GHOSTPROD (December 2022 - March 2023)",
    location: "El Manar, Tunisia",
    des: [
      "Developed the official website of Ghostprod.",
      "Organized and managed the agency resources and data with Odoo Platform.",
      "Arranged meetings with clients and prospected for new opportunities.",
    ],
    keywords: ["NodeJs", "ExpressJs", "ReactJs", "Redux", "MongoDB", "Wix", "WordPress", "Odoo", "Vercel", "Heroku", "Ovh", "FileZilla"]
  },
  {
    id: 3,
    title: "Internship in Web Development",
    subTitle: "PROVESTA SOFT (July 2023 - August 2023)",
    location: "Kelibia, Tunisia",
    des: [
      "Tested and implemented the backend of a CRM system, leading to a 20% increase in system security and stability.",
      "Developed over 10 client interfaces that improved user experience, resulting in a 25% increase in adoption rates among users.",
      "Analyzed data, defined 5 KPIs, and added over 7 visualizations that led to a 15% reduction in process inefficiencies.",
    ],
    keywords: ["Laravel", "ReactJs", "MySQL", "Nivo"]
  },
  {
    id: 4,
    title: "Internship in Business Intelligence",
    subTitle: "SOPRA HR SOFTWARE (February 2024 - July 2024)",
    location: "Tunis, Tunisia",
    des: [
      "Prepared a custom ETL pipeline, leading to a 70% improvement in HR data quality.",
      "Built over 8 interactive dashboards and identified over 30 KPIs, directly enhancing strategic decision-making and reducing report generation time by 30%.",
      "Created a predictive model with 88% accuracy to forecast employee absence days, enabling better workforce planning and reducing absenteeism-related disruptions by 15%.",
      "Designed a web application that integrates all dashboards, ensuring compatibility across multiple devices and systems."
    ],
    keywords: ["Qlik Sense", "Python", "Excel", "Django", "ReactJs", "SQLite"]
  }
];

export const socialWorkData = [
  {
    id: 1,
    title: "Active Member",
    subTitle: "INCEPTUM JUNIOR ENTERPRISE (March 2022 - May 2022)",
    location: "Ariana, Tunisia",
    des: [
      "Developed an ERP Web application for internal management.",
      "Attended JOBS TUNISIA 2022, the biggest job fair in Tunisia, organized by the JET.",
    ],
    keywords: ["NodeJs", "ExpressJs", "ReactJs", "Redux", "MongoDB", "Organisation", "Social Work", "Teamwork"]
  },
  {
    id: 2,
    title: "Team Leader",
    subTitle: "INCEPTUM JUNIOR ENTERPRISE (March 2022 - May 2022)",
    location: "Ariana, Tunisia",
    des: [
      "Managed an Official Website creation project, was part of both the development and the management of the project.",
      "Developed both the backend side and the frontend side of the website.",
      "Tested the website and made sure it was ready for delivery.",
    ],
    keywords: ["NodeJs", "ExpressJs", "ReactJs", "Redux", "MongoDB", "Vercel", "Heroku", "Postman", "Figma", "Project Management", "Team Management", "Leadership", "Teamwork"]
  },
  {
    id: 3,
    title: "Head of Projects Department",
    subTitle: "INCEPTUM JUNIOR ENTERPRISE (June 2022 - May 2023)",
    location: "Ariana, Tunisia",
    des: [
      "Managed a department of over 20 members, leading to a 30% increase in project completion rates.",
      "Signed over 3 new contracts with clients, resulting in a 20% increase in revenue.",
      "Signed the most expensive contract in the history of the association.",
      "Met with clients, ensured the quality of the deliverables, and negotiated the contracts.",
      "Attended JOBS TUNISIA 2023, the biggest job fair in Tunisia, and represented the association as the Head of Projects Department.",
      "Held meetings with partners for potential future collaborations.",
    ],
    keywords: ["Project Management", "Team Management", "Negotiation", "Communication", "Leadership", "Teamwork"]
  },
];

export const skillsData = [
  {
    id: 1,
    icon: <FaReact />,
  },
  {
    id: 2,
    icon: <FaNode />,
  },
  {
    id: 3,
    icon: <SiExpress />,
  },
  {
    id: 4,
    icon: <SiRedux />,
  },
  {
    id: 5,
    icon: <SiMongodb />,
  },
  {
    id: 22,
    icon: <SiMysql />,
  },
  {
    id: 11,
    icon: <FaSymfony />,
  },
  {
    id: 12,
    icon: <FaLaravel />,
  },
  {
    id: 13,
    icon: <SiDotnet />,
  },
  {
    id: 14,
    icon: <SiSpring />,
  },
  {
    id: 26,
    icon: <SiDjango />,
  },
  {
    id: 7,
    icon: <SiPowerbi />,
  },
  {
    id: 8,
    icon: <SiMicrosoftsqlserver />,
  },
  {
    id: 6,
    icon: <SiTalend />,
  },
  {
    id: 9,
    icon: <SiDynamics365 />,
  },
  {
    id: 10,
    icon: <SiSap />,
  },
  {
    id: 21,
    icon: <FaPython />,
  },
  {
    id: 25,
    icon: <FaRProject />,
  },
  {
    id: 17,
    icon: <FaJava />,
  },
  {
    id: 18,
    icon: <FaHtml5 />,
  },
  {
    id: 19,
    icon: <FaCss3Alt />,
  },
  {
    id: 20,
    icon: <DiJavascript />,
  },
  {
    id: 23,
    icon: <FaGit />,
  },
  {
    id: 24,
    icon: <FaGithub />,
  },
  {
    id: 15,
    icon: <FaWordpress />,
  },
  {
    id: 16,
    icon: <FaWix />,
  },
  {
    id: 27,
    icon: <FaFigma />,
  },
]

export const projectsData = [
  {
    id: 1,
    title: "COLIS-19 Web Application",
    des: "A Web Application for parcels delivery management and tracking.",
    src: colis19,
    screenshots: [
      colishome,
      newColis,
      signInInterface,
      signIn,
      signUpInterface,
      signUp,
      sendForm,
      sendFormInterface,
      trackForm,
      trackFormInterface,
      profilePageClient,
      profilePageClientInterface,
      contactForm,
      employeeDashboard,
      adminHome,
      employeesTable,
      employeesTableSm,
    ],
    github: "https://github.com/fouratabdellatif/COLIS-19-Trial-Version",
    weblink: "https://colis-19.netlify.app",
    category: "Web Development",
  },
  {
    id: 2,
    title: "INCEPTUM JE ERP System",
    des: "A Web Application for ERP Management.",
    src: erpInceptum,
    screenshots: [
      login,
      login1,
      meetings1,
      meetingsCollection,
      createMeetingForm1,
      createMeetingForm2,
      meetings2,
      meeting1,
      oneMeetingPage,
      editerReunion,
      members1,
      notif,
      darkmode1,
      darkmode2,
      profile1,
      profile2,
      profile3,
      projects1,
      project1,
      pvForm,
      pv01,
      pv02,
      pv1,
      pv2,
      inceptumeet,
      inceptumeet01,
      inceptumeet02,
      inceptumeet03,
      inceptumeet04,
      inceptumeet05,
    ],
    github: "",
    weblink: "",
    category: "Web Development",
  },
  {
    id: 3,
    title: "GHOSTPROD Official Website",
    des: "A Web Application for the client GHOSTPROD.",
    src: ghostprod,
    screenshots: [
      frontoffice00,
      frontoffice01,
      frontoffice02,
      frontoffice03,
      frontoffice04,
      frontoffice05,
      frontoffice06,
      frontoffice07,
      frontoffice08,
      frontoffice09,
      frontoffice10,
      frontoffice11,
      frontoffice12,
      frontoffice13,
      frontoffice14,
      frontoffice15,
      frontoffice16,
      frontoffice17,
      frontoffice18,
      frontoffice19,
      frontoffice20,
      frontoffice21,
      frontoffice22,
      frontoffice23,
      backoffice00,
      backoffice01,
      backoffice02,
      backoffice03,
      backoffice04,
      backoffice05,
      backoffice06,
      backoffice07,
      backoffice08,
      backoffice09,
      backoffice10,
      backoffice11,
      backoffice12,
      backoffice13,
      mobile00,
      mobile01,
      mobile02,
      mobile03,
      mobile04,
      mobile05,
      mobile06,
      mobile07,
      mobile08,
      mobile09,
      mobile10,
      mobile11,
      mobile12,
      mobile13,
      mobile14,
      mobile15,
      mobile16,
      mobile17,
      mobile18,
      mobile19,
      mobile20,
      mobile21,
      mobile22,
    ],
    github: "",
    weblink: "https://ghostprod.vercel.app",
    category: "Web Development",
  },
  {
    id: 4,
    title: "INCEPTUM JE Official Website",
    des: "The official website for INCEPTUM Junior Enterprise.",
    src: inceptumwebsite,
    screenshots: [
      home00,
      home01,
      home02,
      home03,
      home04,
      home05,
      home06,
      home07,
      home08,
      home09,
      services00,
      services01,
      services02,
      services03,
      services04,
      services05,
      services06,
      services07,
      services08,
      aboutUs00,
      aboutUs01,
      aboutUs02,
      aboutUs03,
      aboutUs04,
      aboutUs05,
      aboutUs06,
      aboutUs07,
      aboutUs08,
    ],
    github: "",
    weblink: "https://inceptumje.tn",
    category: "Web Development",
  },
  {
    id: 5,
    title: "ECODATA BI Dashboard",
    des: "The BI Dashboard version for ECODATA ERP.",
    src: ecodatabi,
    screenshots: [
      top5,
      sales,
      fullfilment,
      customer,
      dark1,
      dark2,
      dark3,
      dark4,
    ],
    github: "",
    weblink: "",
    category: "Business Intelligence",
  },
  {
    id: 6,
    title: "ECODATA ERP Application",
    des: "The Web Application version for ECODATA ERP.",
    src: ecodataweb,
    screenshots: [
      solution,
      pricing,
      dashboard1,
      dashboard2,
      powerbireport,
      products,
      customers,
      profit01,
      daily02,
      forms,
      forms11,
      forms12,
      forms13,
      form01,
      form02,
      form03,
      dashboard02,
      dashboard01,
      products01,
      customers01,
      profit02,
      daily01,
      forms01,
      forms1,
      forms2,
      forms3,
    ],
    github: "",
    weblink: "https://ecodata-erp-dashboard.vercel.app",
    category: "Web Development",
  },
  {
    id: 7,
    title: "PROVESTA SOFT CRM System",
    des: "A Web Application for PROVESTA SOFT CRM Management.",
    src: provestaweb,
    screenshots: [
      c00,
      c01,
      c02,
      c03,
      c0301,
      c04,
      c05,
      c06,
      c07,
      c0701,
      c0702,
      c0703,
      c0704,
      c0705,
      c0706,
      c0707,
      c08,
      cajout,
      cimprimer,
    ],
    github: "",
    weblink: "",
    category: "Web Development",
  },
  {
    id: 8,
    title: "Stroke Analytics BI Dashboard",
    des: "BI Dashboard for healthcare and stroke data analysis.",
    src: strokebi,
    screenshots: [
      home,
      kpis,
      health_conditions,
      res_work_gender,
      smoking_status,
    ],
    github: "",
    weblink: "",
    category: "Business Intelligence",
  },
  {
    id: 9,
    title: "Real Estate Analytics BI Dashboard",
    des: "BI Dashboard for real estate data analysis.",
    src: realestatebi,
    screenshots: [
      realestateOverview,
      quality_price,
      location,
    ],
    github: "",
    weblink: "",
    category: "Business Intelligence",
  },
  {
    id: 10,
    title: "Netflix Analytics BI Dashboard",
    des: "BI Dashboard for Netflix data analysis.",
    src: netflixbi,
    screenshots: [
      page01,
      page02,
    ],
    github: "",
    weblink: "",
    category: "Business Intelligence",
  },
  {
    id: 11,
    title: "HR Analytics BI Dashboard",
    des: "BI Dashboard for HR data analysis.",
    src: hrbi,
    screenshots: [
      general_info,
      employees_satisfaction,
      employees_performance,
      promotion_retreanchment,
      employees_list,
    ],
    github: "",
    weblink: "",
    category: "Business Intelligence",
  },
  {
    id: 12,
    title: "Sopra HR Analytics BI Dashboard",
    des: "The BI Dashboard version for Sopra HR Analytics.",
    src: soprahrbi,
    screenshots: [
      overview,
      demographics,
      establishments,
      absence,
      assignments,
      hiring,
      departure,
      contracts,
      salaryPayroll,
      employeesInfo,
    ],
    github: "",
    weblink: "",
    category: "Business Intelligence",
  },
  {
    id: 13,
    title: "Sopra HR Analytics Web Application",
    des: "The Web Application version for Sopra HR Analytics.",
    src: soprahrweb,
    screenshots: [
      sopraSignUp,
      sopraSignIn,
      overviewPage,
      demographicsPage,
      establishmentsPage,
      absencePage,
      assignmentsPage,
      hiringPage,
      departurePage,
      careers,
      salaryPayrollPage,
      employeesInfoPage,
      configurator,
      tablesPage,
      predictAbsencePage,
      predictedAbsenceDaysResult,
      profilePage,
    ],
    github: "",
    weblink: "",
    category: "Web Development",
  },
]